/**
 * Styled Components - Created by cazarez on 21/02/18.
 */
import styled from 'styled-components'
// import GoogleLogin from 'react-google-login'
import { WHITE, WHITE_TRANSPARENT, GRAY_DARK } from '../../theme/colors'
export const Container = styled.div`
  width: 100%;
  margin-bottom: 30px;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const FacebookButtonWrapper = styled.div`
  position: relative;
  .login-facebook {
    background-color: ${WHITE};
    color: ${GRAY_DARK};
    font-size: inherit;
    padding: 7px 0;
    text-transform: uppercase;
    width: 100%;
    border-radius: 5px;
    border: 2px solid ${GRAY_DARK};
    cursor: pointer;
    box-shadow: none;
    transition: all .25s;
    font-family: Avenir;
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`

export const GoogleButton = styled.div`
  border: 2px solid #5F6062;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 16px;
  align-items: center;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
`

export const GoogleRenderButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background-color: ${WHITE};
  border: 2px solid ${GRAY_DARK};
  color: ${GRAY_DARK};
  margin-bottom: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const SocialIcon = styled.i`
  font-size: 20px !important;
  position: absolute;
  left: 11px;
  top: 4px;
  z-index: 1;
  & img {
    width: 18px;
    border-radius: 3px;
  }
`
export const GoogleLabel = styled.span`
  margin-left: 10px;
`

export const LoadingContainer = styled.div`
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10000;
  height: 100vh;
  background: ${WHITE_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FacebookGmailLogin/styledComponents.tsx